// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"4a481a02","418":"c9bcc278","667":"967f30fc","690":"ceaa2be2","787":"bfcaef17","811":"bdb8bd10"}[chunkId] + ".chunk.js";
};